<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <!-- <el-collapse @change="handleCollapse">
                    <el-collapse-item :title="titleFilter" name="1"> -->
        <div class="row p-3">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              id="farm_irrigation_catching"
              clearable
              v-bind:collapse-tags="true"
              filterable
              @change="handleFarmChange"
              class="select-primary custom-width-select shadow-sm"
              size="large"
              v-model="catchingForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.date') }} *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              @change="handleDateChange"
              :picker-options="pickerOptions"
              class="shadow-sm date-form required-date"
              v-model="catchingForm.date"
              type="date"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.generate') }}
            </l-button>
          </div>
        </div>
        <!-- </el-collapse-item>
                </el-collapse> -->
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="catching"
        :title="$t('irrigation.irrigation_capture')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="custom-flex">
              <el-select
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-select
                clearable
                v-bind:collapse-tags="true"
                filterable
                class="select-primary custom-width-select required-farm shadow-sm"
                style="width: 270px"
                v-model="catchingForm.observation_id"
                :placeholder="`${$t('irrigation.irrigation_news_select')}...`"
              >
                <el-option
                  v-for="(option, index) in observations"
                  class="select-primary"
                  :value="option.irrigation_ob_id"
                  :label="option.observation"
                  :key="index"
                ></el-option>
              </el-select>
              <el-input
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr>
                    <td
                      rowspan="3"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('irrigation.engine') }}
                    </td>
                    <td
                      rowspan="3"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.description') }}
                    </td>
                    <td
                      rowspan="3"
                      class="text-center p-3" 
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('irrigation.irrigation_duration') }} <br />
                      {{ $t('labor.hour_parenthesis') }}
                    </td>
                    <td
                      rowspan="3"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('irrigation.hydrometer_unit') }}
                      <br />
                      {{ $t('common_words.last_reading_actual_reading') }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, i) in queriedData" :key="i">
                    <td class="text-center">{{ data.engine }}</td>
                    <td class="text-center">{{ data.description }}</td>
                    <td class="text-center">
                      <el-input
                        type="text"
                        ref="hourmeter"
                        :id="`hour${i}`"
                        @change="handleHourmeterChange(i)"
                        @input="decimal(i, 'hourmeter')"
                        class="text-center"
                        style="width: 200px"
                        v-model="data.hourmeter"
                        :disabled="data.setDisableHour"
                      />
                    </td>
                    <td class="text-center">
                      <el-input
                        type="text"
                        ref="hydrometer"
                        :id="`hydro${i}`"
                        @input="decimal(i, 'hydrometer')"
                        class="text-center"
                        style="width: 200px"
                        v-model="data.hydrometer"
                        :disabled="data.setDisableHydro"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="my-order">
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>

                <l-pagination
                  class="pagination-no-border"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="pagination.total"
                  pageFirst="false"
                  pageLast="false"
                ></l-pagination>
              </div>

              <label>{{ $t('irrigation.observation_general') }}</label>
              <br />
              <el-input
                id="observation_gral"
                class="shadow-sm"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                :placeholder="$t('common_words.observation')"
                v-model="catchingForm.observation"
              >
              </el-input>

              <div class="buttons-display">
                <div>
                  <label class="label-primary" style="color: transparent">{{
                    $t('common_words.filter')
                  }}</label
                  ><br />
                  <l-button
                    wide
                    type="info"
                    class="btn-filter"
                    style="margin-right: 10px"
                    @click="validateSave"
                    v-show="catching"
                  >
                    {{ $t('common_words.save') }}
                  </l-button>
                </div>
                <div>
                  <label class="label-primary" style="color: transparent">{{
                    $t('common_words.filter')
                  }}</label
                  ><br />
                  <l-button
                    wide
                    type="danger"
                    class="btn-filter"
                    style="margin-left: 10px"
                    @click="deleteCatching"
                    v-show="catching"
                    v-if="bandDelete"
                  >
                    {{ $t('common_words.delete') }}
                  </l-button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import moment from 'moment';
import store from '@/store';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import paginationData from './paginationData';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { Pagination as LPagination } from 'src/components/index';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
  },

  data() {
    return {
      catchingForm: {
        date: null,
        farm_id: null,
        observation_id: null,
        isUpdating: false,
        observation: null,
      },
      bandDelete: true,
      oldValue: null,
      catching: false,
      titleFilter: 'Ocultar filtros',
      farms: [],
      tableData: [],
      observations: [],
      searchQuery: '',
      fuseSearch: null,
      pagination: paginationData.pagination,
      table: paginationData.table,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinMenu],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    validate() {
      return this.$validator.validateAll().then((response) => {
        if (!this.catchingForm.farm_id) {
          let sel = document.getElementById('farm_irrigation_catching');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        if (!this.catchingForm.date) {
          let sel = document.getElementById('date_irrigation_catching');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        this.getCatchings();
        // return response;
      });
    },

    dataInt(i) {
      if (this.queriedData[i].hourmeter)
        this.queriedData[i].hourmeter = this.queriedData[i].hourmeter.replace(
          /[^0-9]/g,
          ''
        );
      if (this.queriedData[i].hydrometer)
        this.queriedData[i].hydrometer = this.queriedData[i].hydrometer.replace(
          /[^0-9]/g,
          ''
        );
    },

    decimal(i, key) {
      let exp_val = /^(\d)?(\d|,)*\.?\d*$/;
      if (!exp_val.test(this.queriedData[i][key])) {
        this.$set(this.queriedData[i], key, this.oldValue);
      } else {
        this.oldValue = this.queriedData[i][key];
      }

      if (this.queriedData[i].hourmeter > 24) {
        SweetAlert.warning(i18n.t('sweet_alert.irrigation.maximum_hours'));
        this.$set(this.queriedData[i], 'hourmeter', '');
      }
    },

    handleHourmeterChange(i) {
      if (!this.tableData[i]['has_hydrometer']) {
        let houmeter = Number.parseFloat(this.$refs.hourmeter[i].value);
        houmeter = isNaN(houmeter) ? 0 : houmeter;
        this.tableData[i]['hydrometer'] =
          ((this.tableData[i]['irrigation_area'] *
            10 *
            this.tableData[i]['lamina']) /
            this.tableData[i]['irrigation_blocks']) *
          houmeter;
      }
    },

    getCatchings() {
      this.catchingForm.observation = null;
      this.tableData = [];
      this.showHideLoading(true);
      let data = {
        farm_id: this.catchingForm.farm_id,
        date: moment(this.catchingForm.date).format('YYYY-MM-DD'),
        route: 'irrigation/catching',
        catchingData: this.tableData,
      };
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length > 0) {
            this.catching = true;
            this.catchingForm.isUpdating = false;
            if (this.tableData[0].date_save && this.tableData[0].detail_id)
              this.bandDelete = true;
            else this.bandDelete = false;
            if (this.tableData.length > 0) {
              this.catchingForm.observation_id =
                this.tableData[0].observation_id;
              this.catchingForm.observation = this.tableData[0].observations;
            }

            for (let i = 0; i < this.tableData.length; i++) {
              if (!this.tableData[i]['has_hydrometer']) {
                let hydrometer =
                  ((this.tableData[i]['irrigation_area'] *
                    10 *
                    this.tableData[i]['lamina']) /
                    this.tableData[i]['irrigation_blocks']) *
                  this.tableData[i]['hourmeter'];

                Number.isNaN(hydrometer)
                  ? (this.tableData[i]['hydrometer'] = null)
                  : (this.tableData[i]['hydrometer'] = hydrometer);

                this.tableData[i]['setDisableHydro'] = true;
              } else {
                this.tableData[i]['setDisableHydro'] = false;
              }
            }

            response.data.updating
              ? (this.catchingForm.isUpdating = true)
              : (this.catchingForm.isUpdating = false);
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.table.map((prop) => {
                return prop.prop;
              }),
            });
          } else {
            SweetAlert.warning(
              i18n.t('sweet_alert.irrigation.no_parameters_farm') +
                ' ' +
                document.getElementById('farm_irrigation_catching').value
            );
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.danger(
            error.response.data.message ? error.response.data.message : error
          );
        });
    },

    validateSave() {
      let band = true;
      this.tableData.forEach((data, index) => {
        if (data.hourmeter == null || data.hourmeter == '') {
          let sel = document.getElementById(`hour${index}`);
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          band = false;
        }

        if (data.hydrometer == null || data.hydrometer == '') {
          let sel = document.getElementById(`hydro${index}`);
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          band = false;
        }

        /* if (this.catchingForm.observation == null || this.catchingForm.observation == '') {
          let sel = document.getElementById('observation_gral');
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          band = false;
        }*/
      });

      if (band) {
        this.saveCatching();
      }
    },

    saveCatching() {
      this.showHideLoading(true);
      let data = {
        farm_id: this.catchingForm.farm_id,
        observation_id: this.catchingForm.observation_id,
        observations: this.catchingForm.observation,
        date_save: moment(this.catchingForm.date).format('YYYY-MM-DD'),
        route: 'irrigation/catching/store',
        catchingData: this.tableData,
        updating: this.catchingForm.isUpdating,
      };
      Axios.postMasters(data)
        .then((response) => {
          this.catching = false;
          this.tableData = [];
          //this.observations = [];
          this.showHideLoading();
          SweetAlert.success(
            response.data.message ? response.data.message : response.errors
          );
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.danger(
            error.response.data.message ? error.response.data.message : error
          );
        });
    },

    deleteCatching() {
      let farm_name = document.getElementById('farm_irrigation_catching').value;
      SweetAlert.delete(
        i18n.t('sweet_alert.irrigation.farm_record') +
          farm_name +
          i18n.t('sweet_alert.irrigation.on_date') +
          moment(this.catchingForm.date).format('YYYY-MM-DD')
      ).then((result) => {
        if (result.value) {
          if (this.tableData[0].header_id) {
            this.showHideLoading(true);
            let data = {
              id: this.tableData[0].header_id,
              route: 'irrigation/catching/delete',
            };
            Axios.destroyMaster(data)
              .then((response) => {
                this.catchingForm.isUpdating = false;
                this.tableData.forEach((engine) => {
                  engine.hourmeter = null;
                  engine.hydrometer = null;
                  this.catchingForm.observation_id = null;
                  this.catchingForm.observation = null;
                  this.bandDelete = false;
                });
                this.showHideLoading();
                SweetAlert.success(
                  response.data.message
                    ? response.data.message
                    : response.errors
                );
              })
              .catch((error) => {
                this.showHideLoading();
                SweetAlert.danger(
                  error.response.data.message
                    ? error.response.data.message
                    : i18n.t('sweet_alert.irrigation.deleted_record_error')
                );
              });
          }
        }
      });
    },

    handleFarmChange() {
      this.catching = false;
      this.tableData = [];
    },

    handleDateChange() {
      this.catching = false;
      this.tableData = [];
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('irrigation/catchingsobservations'),
      ])
        .then((responses) => {
          const [response_farms, response_observations] = responses;
          this.farms = response_farms.data.data;
          this.observations = response_observations.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
        });
    }
  },

  mounted() {
    this.selectedItemOnMenu('irrigation');
  },

  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>
<style scoped>
.my-order {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.buttons-display {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}
</style>
